import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import config from '../config/apiConfig';

const apiUrl = config.api_url;

export const usarEstadoSuscripcion = () => {
    // Definimos el estado de la suscripción.
    // Inicialmente, será 'cargando' (loading).
    const [estado, setEstado] = useState('cargando');
    
    // Usamos useEffect para simular la llamada a la API
    useEffect(() => {
        // En un entorno real, aquí harías una llamada 'fetch' a tu backend.
        // Ejemplo: fetch('/api/estado-suscripcion')
        
        // Simulamos un retraso para imitar una llamada de red.
        const timer = setTimeout(() => {
            // Aquí, en el código real, recibirías la respuesta de tu backend
            // y actualizarías el estado. Por ahora, devolvemos 'expirado'.
            setEstado('expired');
        }, 1500); // 1.5 segundos de retraso
        
        // Función de limpieza para evitar errores si el componente se desmonta.
        return () => clearTimeout(timer);
    }, []); // El array vacío asegura que la función solo se ejecute una vez al cargar.
    
    // Devolvemos el estado de la suscripción.
    return { estado };
};


export const RegistroPeriodoPruebas = async (datos, setLoading =false) => {
      
        setLoading(true);
        try {
            const respuesta = await axios.post(apiUrl + 'clientesApp/registrar/', {datos});
            
            if (respuesta.data.completado) {
                toast.success("¡Registro completado con éxito!");
            } else {
                toast.error(respuesta.data.mensaje);
            }
        } catch (error) {
            console.error(error);
            toast.error("Ha ocurrido un error al intentar registrar.");
        } finally {
            setLoading(false);
        }
};
